import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import { SuiviRepresentantDetailPage, SuiviRepresentantListPage } from ".";

export interface SuiviRepresentantProps {}

export const SuiviRepresentant: React.FunctionComponent<SuiviRepresentantProps> = props => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <SuiviRepresentantListPage />
      </Route>
      <Route path={`${match.path}/:suiviId?`} component={SuiviRepresentantDetailPage} exact />
    </Switch>
  );
};
